export const handleFormatMoney = (value) => {
    const number = String(value)
        .replace(/\D/g, "")
        .replace(/^0+/, "")

    let counter = 1
    let isCommaFound = "notFound"

    const formattedStringReversed = Array
        .from(number.toString())
        .reverse()
        .reduce((acc, i, index, arr) => {
            if (counter === 2 &&
                isCommaFound === "notFound" &&
                (arr.length > 2)
            ) {
                acc = acc + i + ','
                isCommaFound = "found"
                counter = 0
            } else if (counter === 3 && (arr.length !== (index + 1))) {
                acc = acc + i + '.'
                counter = 0
            } else {
                acc = acc + i
            }

            counter++
            return acc
        }, "")

    let formatedNUmber = Array.from(formattedStringReversed)
        .reverse().join("")

    if (formatedNUmber.length === 2) {
        formatedNUmber = "0," + formatedNUmber
    } else if (formatedNUmber.length === 1) {
        formatedNUmber = "0,0" + formatedNUmber
    }

    return formatedNUmber
}
